import React from 'react';

const Category = ({
  event,
  closeModal,
  servicesCategories,
  onChangeCategory,
}) => {
  return (
    <div>
      <div
        className="bg-white w-100 border-bottom"
        style={{
          zIndex: 9998,
          borderRadius: '16px 16px 0 0',
          position: 'fixed',
        }}
      >
        <button
          type="button"
          className="close close__modal position--modalclose"
          aria-label="Close"
          onClick={() => closeModal()}
        >
          <span className="text-fz-24px float-right m-2" aria-hidden="true">
            ×
          </span>
        </button>
      </div>
      <div
        className="card bg-gray"
        style={{ paddingTop: '38px', paddingBottom: '144px' }}
      >
        <div className="card bg-white h-100">
          <div className="bg-white">
            <div className="pl-0 pr-0">
              {servicesCategories
                .sort((a, b) => a.id - b.id)
                .map((servicesCategory) => {
                  return (
                    <ServicesCategoryBox
                      key={servicesCategory.id}
                      servicesCategory={servicesCategory}
                      selectedCategoryId={event.category_id}
                      isOpen={servicesCategory.categories.some(
                        (category) => category.id == event.category_id
                      )}
                      onChangeCategory={onChangeCategory}
                    />
                  );
                })}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const ServicesCategoryBox = ({
  servicesCategory,
  selectedCategoryId,
  isOpen,
  onChangeCategory,
}) => {
  const [showMore, setShowMore] = React.useState(false);

  return (
    <div className="accordion" id="accordionExample">
      <div className="card border-top-0 border-right-0 border-left-0 border-bottom rounded-0">
        <div
          className="card-header bg-white p-3"
          id={`#heading${servicesCategory.id}`}
        >
          <a
            className="p-0 nav-link link--arrow line-height-2 cursor-pointer"
            data-toggle="collapse"
            data-target={`#collapse${servicesCategory.id}`}
            aria-expanded="false"
            aria-controls={`collapse${servicesCategory.id}`}
          >
            {servicesCategory.name}
          </a>
        </div>
      </div>

      <div
        id={`collapse${servicesCategory.id}`}
        className={`collapse ${isOpen ? 'show' : ''}`}
        aria-labelledby={`#heading${servicesCategory.id}`}
        data-parent="#accordionExample"
      >
        <div className="card-body p-0">
          <ul className="nav flex-column">
            {servicesCategory.categories
              .filter((category) => category.services_category.is_primary)
              .map((category) => (
                <li className="nav-item p-3 border-bottom" key={category.id}>
                  <label className="d-flex justify-content-between align-items-center mb-0 position-relative">
                    <p className="p-0 line-height-2 pl-3 mb-0">
                      {category.name}
                    </p>
                    <input
                      type="checkbox"
                      name="category"
                      id=""
                      className="d-none checkbox__input"
                      onChange={onChangeCategory}
                      value={category.id}
                      checked={Number(selectedCategoryId) === category.id}
                    />
                    <span className="checkbox__lg" />
                  </label>
                </li>
              ))}
            {/* <li className="nav-item p-3 border-bottom">
              <a
                className="nav-link text-black-20 p-0 link--arrow -bottom line-height-2 pl-3 text-center"
                onClick={() => setShowMore((prev) => !prev)}
                data-value={servicesCategory.id}
              >
                {showMore ? '閉じる' : 'もっと見る'}
              </a>
            </li>
            {showMore &&
              servicesCategory.categories
                .filter((category) => !category.services_category.is_primary)
                .map((category) => (
                  <li className="nav-item p-3 border-bottom" key={category.id}>
                    <label className="d-flex justify-content-between align-items-center mb-0 position-relative">
                      <p href="" className="p-0 line-height-2 pl-3 mb-0">
                        {category.name}
                      </p>
                      <input
                        type="checkbox"
                        name="category"
                        id=""
                        className="d-none checkbox__input"
                        onChange={onChangeCategory}
                        value={category.id}
                        checked={Number(selectedCategoryId) === category.id}
                      />
                      <span className="checkbox__lg" />
                    </label>
                  </li>
                ))} */}
          </ul>
        </div>
      </div>
    </div>
  );
};


export default Category;